import http from './http'

const getEntities = async () => (await http.get('/entities')).data.data.docs

const getEvents = async () => (await http.get('/events')).data.data.docs

const getPropsEvents = async ({ id, format = '' }) => (await http.get(`/events/props/${id}?format=${format}`)).data.data.docs

const getPropsEntities = async ({ id }) => (await http.get(`/entities/props/${id}`)).data.data.docs

const serialize = (obj, prefix) => {
  const str = []
  for (const p in obj) {
    if (obj[p]) {
      const k = prefix ? prefix + '[' + p + ']' : p
      const v = obj[p]
      str.push((v !== null && typeof v === 'object') ? serialize(v, k) : encodeURIComponent(k) + '=' + encodeURIComponent(v))
    }
  }
  return str.join('&')
}

const getSegments = async ({ page, limit = 10, jobId = null, filter = null }) => {
  return (await http.get(`segments?${serialize({ page, limit, jobId, filter })}`)).data
}

const getComboOptions = async ({ registerType, type, field, isArray = false }) => (await http.get(`/${registerType}/combo/${type}/${field}?isArray=${isArray}`)).data.data.docs

const getSegment = async ({ id }) => (await http.get(`segments/${id}`)).data

const createSegment = async (payload) => (await http.post('/segments', payload)).data

const updateSegment = async (id, payload) => (await http.patch(`/segments/${id}`, payload)).data

const validateSegment = async (payload) => (await http.post('/segments/validate', payload)).data

const importSegment = async (model, payload) => (await http.post(`/segments/import/${model}`, payload)).data

export {
  getEntities,
  getEvents,
  getPropsEvents,
  getPropsEntities,
  getComboOptions,
  getSegments,
  getSegment,
  createSegment,
  updateSegment,
  validateSegment,
  importSegment
}
